import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface ScrollState {
  preserveScroll?: boolean;
}

export function ScrollToTop() {
  const location = useLocation();
  const state = location.state as ScrollState | null;

  useEffect(() => {
    // Skip scroll reset if navigation requested scroll preservation
    if (state?.preserveScroll) return;
    window.scrollTo(0, 0);
  }, [location.pathname, state?.preserveScroll]);

  return null;
}
